<mat-card class="chart-card">
    <mat-card-content>
        <!-- Chart Section -->
        <div class="chart-container">
            <div class="chart-wrapper">
                <svg viewBox="0 0 36 36" class="donut-chart">
                    <!-- Hole / Background -->
                    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                        stroke="#F4F7FE" stroke-width="6" />

                    <!-- Segments -->
                    <ng-container *ngFor="let item of legendItems">
                        <path class="chart-segment" [attr.stroke-dasharray]="item.dashArray"
                            [attr.stroke-dashoffset]="item.dashOffset" [attr.stroke]="item.color"
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none" stroke-width="6" stroke-linecap="round" (mouseenter)="onSegmentHover(item)"
                            (mouseleave)="onSegmentLeave()" />
                    </ng-container>
                </svg>
                <div class="chart-text">
                    <span class="total-label">{{ hoveredItem ? hoveredItem.name : 'Overall Spent' }}</span>
                    <span class="total-amount">{{ (hoveredItem ? hoveredItem.amount : totalBalance) |
                        currency:'INR':'symbol':'1.0-2' }}</span>
                </div>
            </div>
        </div>

        <!-- Category List -->
        <div class="category-list">
            <div class="list-item" *ngFor="let item of legendItems">
                <div class="item-left">
                    <div class="item-icon" [style.background-color]="item.color + '20'" [style.color]="item.color">
                        <mat-icon>{{ item.icon }}</mat-icon>
                    </div>
                    <div class="item-details">
                        <span class="item-name">{{ item.name }}</span>
                        <span class="item-amount">{{ item.amount | currency:'INR':'symbol':'1.0-2' }}</span>
                    </div>
                </div>
                <span class="item-percent" [style.color]="item.color">{{ item.percentage | number:'1.0-1' }}%</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>